import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as FaqItemDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/FaqItemBlock/FaqItemDefaultData";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";

export const createFaqItemBlock = ({
  question = "",
  answer = "",
}: {
  question?: string;
  answer?: string;
}): BaseBlock => ({
  ...FaqItemDefaultData,
  id: uuidv4(),
  props: {
    ...FaqItemDefaultData.props,
    header: {
      ...FaqItemDefaultData.props.header,
      prop: "children",
      type: "children",
      value: [
        createH5Block({
          text: question,
        }),
      ],
    },
    content: {
      ...FaqItemDefaultData.props.content,
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: answer,
        }),
      ],
    },
  },
});
